import type { ComponentProps } from "react";

import { useSelector } from "react-redux";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import trackingService from "app/pages/sales-intelligence/sub-modules/opportunities/services/tracking/trackingService";

import { extractCrmAndObjectType } from "../../../helpers/crmList";
import { selectGroupedOpportunityListOptions, selectRecentlyViewedOpportunityList } from "../../../store/selectors";
import type { OpportunityListOption } from "../../../types";
import { OpportunityListVariant } from "../../../types";

import DropdownButton from "./DropdownButton/DropdownButton";
import OpportunityListsDropdown from "./OpportunityListsDropdown";

type DropdownProps = ComponentProps<typeof OpportunityListsDropdown>;
type Props = Partial<Pick<DropdownProps, "renderDropdownButton" | "className">> & {
    selectedList: OpportunityListOption;
};

const ListsDropdownContainer = ({ className, renderDropdownButton = DropdownButton, selectedList }: Props) => {
    const groupedLists = useSelector(selectGroupedOpportunityListOptions);
    const recentlyViewedOpportunityList = useSelector(selectRecentlyViewedOpportunityList);

    const handleListSelect = (selectedList: OpportunityListOption): void => {
        trackingService.trackListSelectFromDD(selectedList.name);
        if (selectedList.variant === OpportunityListVariant.Static) {
            void siNavigator.goToStaticListPage(
                {
                    id: selectedList.id,
                    isRecent: recentlyViewedOpportunityList?.opportunityListId === selectedList.id,
                },
                { reload: true },
            );
        } else if (selectedList.variant === OpportunityListVariant.Crm) {
            const { crm, objectType } = extractCrmAndObjectType(selectedList.id);

            void siNavigator.goToCrmListPage({ crm, objectType }, { reload: true });
        }
    };

    return (
        <OpportunityListsDropdown
            className={className}
            renderDropdownButton={renderDropdownButton}
            groupedLists={groupedLists}
            selected={selectedList}
            onSelect={handleListSelect}
        />
    );
};

export default ListsDropdownContainer;
